import { render, staticRenderFns } from "./yiXinApplicationPreview.vue?vue&type=template&id=80972a4e"
import script from "./yiXinApplicationPreview.vue?vue&type=script&lang=js"
export * from "./yiXinApplicationPreview.vue?vue&type=script&lang=js"
import style0 from "./yiXinApplicationPreview.vue?vue&type=style&index=0&id=80972a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports